/* ============================================================================
   SANTINI — Store Locator
   Google Maps JavaScript API + MarkerClusterer
   ----------------------------------------------------------------------------
   Init: caricato dallo script Google con &callback=SantiniStoreLocator.init
   ========================================================================== */

window.SantiniStoreLocator = (function () {
  "use strict";

  /* Stile mappa grayscale (desaturato, editoriale) */
  var MAP_STYLE = [
    { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#8a8a8a" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
    { featureType: "administrative", elementType: "geometry", stylers: [{ visibility: "off" }] },
    { featureType: "administrative.country", elementType: "labels.text.fill", stylers: [{ color: "#9a9a9a" }] },
    { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
    { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#7a7a7a" }] },
    { featureType: "poi", stylers: [{ visibility: "off" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
    { featureType: "road", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#ededed" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#e3e3e3" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#dddddd" }] },
    { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] }
  ];

  /* Icona SVG marker singolo: cerchio nero */
  function singleMarkerIcon() {
    var svg =
      '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">' +
      '<circle cx="11" cy="11" r="9" fill="#111111" stroke="#ffffff" stroke-width="2"/>' +
      "</svg>";
    return {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(22, 22),
      anchor: new google.maps.Point(11, 11)
    };
  }

  /* Renderer cluster: cerchio nero con conteggio bianco */
  var clusterRenderer = {
    render: function (cluster) {
      var count = cluster.count;
      var pos = cluster.position;
      var r = count < 10 ? 20 : count < 100 ? 24 : 28;
      var size = r * 2;
      var svg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="' + size + '" height="' + size +
        '" viewBox="0 0 ' + size + " " + size + '">' +
        '<circle cx="' + r + '" cy="' + r + '" r="' + r + '" fill="#111111"/>' +
        "</svg>";
      return new google.maps.Marker({
        position: pos,
        icon: {
          url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
          scaledSize: new google.maps.Size(size, size),
          anchor: new google.maps.Point(r, r)
        },
        label: {
          text: String(count),
          color: "#ffffff",
          fontSize: "13px",
          fontWeight: "600",
          fontFamily: "Inter, Helvetica, Arial, sans-serif"
        },
        zIndex: 1000 + count
      });
    }
  };

  /* ── Stato modulo ──────────────────────────────────────────────────────── */
  var map, clusterer;
  var defaultZoom = 2;
  var stores = [];
  var suggestSource = [];     // elenco luoghi (città/regione/paese) per i suggerimenti
  var markers = [];           // marker google per ogni store, indicizzati come gli store
  var els = {};               // riferimenti DOM
  var visibleIds = [];        // id store attualmente nel viewport
  var activeStoreId = null;
  var searchResults = null;   // risultati ricerca attiva (null = nessuna ricerca)
  var built = false;          // UI già costruita (indipendente dalla mappa)
  var mapFailed = false;      // la mappa non è disponibile

  /* Etichette tradotte: lette dai data-attribute della .sl-root (dalla section
     via filtro Liquid | t). Fallback in italiano se l'attributo manca. */
  var i18n = {
    searchPlaceholder: "Cerca per paese, regione o città",
    allStores: "Tutti i negozi",
    storesTitle: "Negozi",
    searchAria: "Cerca",
    clearAria: "Cancella",
    closeAria: "Chiudi",
    filterTitle: "Filtra",
    filterNote: "Nessun filtro configurato. Questo pannello è predisposto: definiremo i criteri (es. tipo negozio, paese) quando arriveranno i dati reali.",
    mapUnavailableTitle: "Mappa non disponibile",
    mapUnavailableText: "Usa la ricerca e l'elenco per trovare il negozio. Le indicazioni stradali si aprono comunque in Google Maps.",
    storeOne: "Negozio",
    storeMany: "Negozi",
    emptySearchTitle: "Nessun negozio trovato.",
    emptySearchHint: "Prova con un'altra città, regione o paese.",
    emptyAreaTitle: "Nessun negozio in quest'area.",
    emptyAreaHint: "Sposta la mappa o cerca una località.",
    directions: "Indicazioni",
    visitSite: "Visita il sito"
  };

  /* ── Helpers DOM ───────────────────────────────────────────────────────── */
  function $(sel, root) { return (root || document).querySelector(sel); }

  /* Escape per valori inseriti in HTML/attributi costruiti via stringa */
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }

  function icon(name) {
    var paths = {
      search: '<path d="M11 4a7 7 0 1 0 4.9 12l4.05 4.05 1.4-1.42L17.3 14.6A7 7 0 0 0 11 4Zm0 2a5 5 0 1 1 0 10 5 5 0 0 1 0-10Z"/>',
      close: '<path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2" fill="none"/>',
      pin: '<path d="M12 2a7 7 0 0 0-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z"/>',
      phone: '<path d="M6.6 10.8a15 15 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24 11 11 0 0 0 3.5.56 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1 11 11 0 0 0 .56 3.5 1 1 0 0 1-.25 1Z"/>',
      mail: '<path d="M3 5h18v14H3V5Zm2 2v.5l7 4.5 7-4.5V7H5Zm14 2.8-7 4.5-7-4.5V17h14V9.8Z"/>',
      web: '<path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm6.9 6h-2.9a15 15 0 0 0-1.2-3.6A8 8 0 0 1 18.9 8ZM12 4c.8 1 1.5 2.4 1.9 4h-3.8c.4-1.6 1.1-3 1.9-4ZM4.3 14a8 8 0 0 1 0-4h3.3a18 18 0 0 0 0 4H4.3Zm.8 2h2.9a15 15 0 0 0 1.2 3.6A8 8 0 0 1 5.1 16Zm2.9-8H5.1a8 8 0 0 1 4.1-3.6A15 15 0 0 0 8 8Zm4 12c-.8-1-1.5-2.4-1.9-4h3.8c-.4 1.6-1.1 3-1.9 4Zm2.3-6H9.7a16 16 0 0 1 0-4h4.6a16 16 0 0 1 0 4Zm.6 5.6a15 15 0 0 0 1.2-3.6h2.9a8 8 0 0 1-4.1 3.6ZM16.4 14a18 18 0 0 0 0-4h3.3a8 8 0 0 1 0 4h-3.3Z"/>',
      clock: '<path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Zm.5-13H11v6l5 3 .8-1.3-4.3-2.5V7Z"/>',
      back: '<path d="M14 6l-6 6 6 6" stroke="currentColor" stroke-width="2" fill="none"/>',
      directions: '<path d="M21.7 11.3 12.7 2.3a1 1 0 0 0-1.4 0l-9 9a1 1 0 0 0 0 1.4l9 9a1 1 0 0 0 1.4 0l9-9a1 1 0 0 0 0-1.4ZM13 16v-2.5h-3V16L6.5 12.5 10 9v2.5h4.5V15l3.5-3.5L13 8Z"/>'
    };
    var stroked = name === "close" || name === "back";
    return '<svg viewBox="0 0 24 24" fill="' + (stroked ? "none" : "currentColor") +
      '" xmlns="http://www.w3.org/2000/svg">' + paths[name] + "</svg>";
  }

  /* ── Boot: UI + ricerca + lista (indipendente da Google Maps) ──────────── */
  function boot() {
    if (built) return;
    var root = $(".sl-root");
    if (!root) { console.error("[Santini] .sl-root non trovato"); return; }
    built = true;
    els.root = root;

    /* Etichette tradotte passate dalla section via blocco JSON (.sl-i18n).
       Sovrascrive i default italiani solo con valori non vuoti. */
    var i18nNode = document.querySelector(".sl-i18n");
    if (i18nNode) {
      try {
        var parsed = JSON.parse(i18nNode.textContent);
        for (var k in parsed) {
          if (Object.prototype.hasOwnProperty.call(parsed, k) && parsed[k]) i18n[k] = parsed[k];
        }
      } catch (e) {
        if (window.console) console.warn("[Santini] etichette i18n non valide:", e);
      }
    }

    stores = (window.SANTINI_STORES || []).filter(function (s) {
      return typeof s.lat === "number" && typeof s.lng === "number";
    });
    defaultZoom = parseInt(root.getAttribute("data-default-zoom"), 10) || 2;

    buildUI(root);
    buildSearchIndex();
    refreshLabel();
    loadRemoteStores();   // se configurato, sostituisce i dati con quelli live

    /* Se entro qualche secondo la mappa non è pronta, mostra il placeholder
       ma la ricerca/lista restano pienamente funzionanti. */
    setTimeout(function () { if (!map) mapUnavailable(); }, 6000);
  }

  /* ── Dati remoti (JSON live) ────────────────────────────────────────────
     Se .sl-root ha l'attributo data-stores-url, carica i negozi da lì.
     In caso di errore restano i dati incorporati (fallback): mai pagina vuota. */
  function loadRemoteStores() {
    var url = els.root && els.root.getAttribute("data-stores-url");
    if (!url) return;
    if (!window.fetch) return;
    fetch(url, { credentials: "omit" })
      .then(function (r) { if (!r.ok) throw new Error("HTTP " + r.status); return r.json(); })
      .then(function (data) {
        var list = Array.isArray(data) ? data : (data && data.stores);
        if (Array.isArray(list) && list.length) applyStores(list);
      })
      .catch(function (e) {
        if (window.console) console.warn("[Santini] dati remoti non caricati, uso i dati locali:", e);
      });
  }

  /* Applica un nuovo set di negozi (da fonte remota) e aggiorna tutto */
  function applyStores(list) {
    stores = list.filter(function (s) {
      s.lat = typeof s.lat === "string" ? parseFloat(s.lat) : s.lat;
      s.lng = typeof s.lng === "string" ? parseFloat(s.lng) : s.lng;
      return typeof s.lat === "number" && !isNaN(s.lat) &&
             typeof s.lng === "number" && !isNaN(s.lng);
    });
    buildSearchIndex();

    if (map) {                                  // ricostruisci i marker sulla mappa
      if (clusterer) clusterer.clearMarkers();
      buildMarkers();
      if (clusterer) clusterer.addMarkers(markers);
    }

    searchResults = null;
    refreshLabel();
    if (els.sidebar.classList.contains("is-open") && !activeStoreId) renderList();
  }

  /* ── Init mappa (callback Google Maps) ─────────────────────────────────── */
  function init() {
    boot();                                   // assicura UI pronta
    if (map) return;                          // evita doppia init (re-render Shopify)
    if (!window.google || !google.maps) return;
    mapFailed = false;

    map = new google.maps.Map(els.map, {
      center: { lat: 30, lng: 20 },
      zoom: defaultZoom,
      minZoom: 2,
      styles: MAP_STYLE,
      disableDefaultUI: true,
      zoomControl: true,
      gestureHandling: "greedy",
      backgroundColor: "#f2f2f2"
    });

    buildMarkers();
    clusterer = new markerClusterer.MarkerClusterer({
      map: map,
      markers: markers,
      renderer: clusterRenderer
    });

    map.addListener("idle", updateVisible);
    map.addListener("click", function () { closeSuggest(); });

    if (searchResults && searchResults.length) fitToStores(searchResults);
  }

  /* Mappa non disponibile: mostra un avviso al posto della mappa,
     senza bloccare ricerca/lista. */
  function mapUnavailable() {
    if (map || mapFailed || !els.map) return;
    mapFailed = true;
    els.map.innerHTML =
      '<div class="sl-map__ph">' +
        '<div class="sl-map__ph-inner">' +
          '<p class="sl-map__ph-title">' + esc(i18n.mapUnavailableTitle) + '</p>' +
          '<p class="sl-map__ph-text">' + esc(i18n.mapUnavailableText) + '</p>' +
        '</div>' +
      '</div>';
    openSidebar();   // mostriamo subito l'elenco, è la via principale senza mappa
  }

  /* ── Costruzione UI ────────────────────────────────────────────────────── */
  function buildUI(root) {
    root.innerHTML =
      '<div class="sl-map"></div>' +

      '<div class="sl-search">' +
        '<div class="sl-search__box">' +
          '<input class="sl-search__input" type="text" autocomplete="off" ' +
            'placeholder="' + esc(i18n.searchPlaceholder) + '" aria-label="' + esc(i18n.searchAria) + '">' +
          '<button class="sl-search__btn" type="button" aria-label="' + esc(i18n.searchAria) + '">' + icon("search") + '</button>' +
        '</div>' +
        '<button class="sl-search__clear" type="button" aria-label="' + esc(i18n.clearAria) + '">' + icon("close") + '</button>' +
        '<div class="sl-suggest"></div>' +
      '</div>' +

      '<div class="sl-controls">' +
        '<button class="sl-control" data-action="all">' +
          '<span class="sl-control__label">' + esc(i18n.allStores) + '</span>' +
          '<span class="sl-control__plus">+</span>' +
        '</button>' +
        /* "Filtra" disabilitato: pannello non ancora configurato. */
      '</div>' +

      '<div class="sl-filter">' +
        '<p class="sl-filter__title">' + esc(i18n.filterTitle) + '</p>' +
        '<p class="sl-filter__note">' + esc(i18n.filterNote) + '</p>' +
      '</div>' +

      '<aside class="sl-sidebar">' +
        '<div class="sl-sidebar__head">' +
          '<span class="sl-sidebar__title">' + esc(i18n.storesTitle) + ' <span class="sl-sidebar__count"></span></span>' +
          '<button class="sl-sidebar__back" type="button">' + icon("back") + " " + esc(i18n.allStores) + "</button>" +
          '<button class="sl-sidebar__close" type="button" aria-label="' + esc(i18n.closeAria) + '">' + icon("close") + '</button>' +
        '</div>' +
        '<div class="sl-sidebar__body"></div>' +
      '</aside>';

    els.map = $(".sl-map", root);
    els.input = $(".sl-search__input", root);
    els.searchBtn = $(".sl-search__btn", root);
    els.clearBtn = $(".sl-search__clear", root);
    els.suggest = $(".sl-suggest", root);
    els.controls = $(".sl-controls", root);
    els.filterPanel = $(".sl-filter", root);
    els.sidebar = $(".sl-sidebar", root);
    els.sidebarBody = $(".sl-sidebar__body", root);
    els.sidebarCount = $(".sl-sidebar__count", root);
    els.sidebarBack = $(".sl-sidebar__back", root);
    els.allLabel = $('.sl-control[data-action="all"] .sl-control__label', root);

    /* Eventi ricerca */
    els.searchBtn.addEventListener("click", runSearch);
    els.input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); runSearch(); closeSuggest(); }
    });
    els.input.addEventListener("input", onType);
    els.clearBtn.addEventListener("click", clearSearch);

    /* Controlli */
    els.controls.addEventListener("click", function (e) {
      var btn = e.target.closest(".sl-control");
      if (!btn) return;
      if (btn.dataset.action === "all") { els.filterPanel.classList.remove("is-open"); backToList(); openSidebar(); }
      if (btn.dataset.action === "filter") { els.filterPanel.classList.toggle("is-open"); }
    });

    $(".sl-sidebar__close", root).addEventListener("click", closeSidebar);
    if (els.sidebarBack) els.sidebarBack.addEventListener("click", backToList);
  }

  /* Torna alla lista completa: ripristina la vista d'insieme (lo zoom sul
     negozio aveva ristretto il viewport a un solo negozio) e mostra tutti. */
  function backToList() {
    activeStoreId = null;
    els.sidebar.classList.remove("is-detail");
    var list = (searchResults && searchResults.length) ? searchResults : stores;
    if (map) fitToStores(list);
    visibleIds = [];
    renderList();
  }

  /* ── Marker ────────────────────────────────────────────────────────────── */
  function buildMarkers() {
    var ic = singleMarkerIcon();
    markers = stores.map(function (store) {
      var m = new google.maps.Marker({
        position: { lat: store.lat, lng: store.lng },
        icon: ic,
        title: store.name
      });
      m._storeId = store.id;
      m.addListener("click", function () {
        openSidebar();
        focusStore(store.id);
      });
      return m;
    });
  }

  /* ── Conteggio negozi nel viewport ─────────────────────────────────────── */
  function updateVisible() {
    if (!map) return;
    var bounds = map.getBounds();
    if (!bounds) return;
    visibleIds = stores
      .filter(function (s) { return bounds.contains({ lat: s.lat, lng: s.lng }); })
      .map(function (s) { return s.id; });

    if (searchResults) return;   // ricerca attiva: non sovrascrivere coi risultati del viewport
    refreshLabel();
    if (els.sidebar.classList.contains("is-open") && !activeStoreId) renderList();
  }

  function visibleStores() {
    if (!visibleIds.length) return stores.slice();
    return stores.filter(function (s) { return visibleIds.indexOf(s.id) !== -1; });
  }

  /* Negozi da mostrare nella lista, in ordine di priorità:
     ricerca attiva → viewport (se c'è mappa) → tutti. */
  function currentStores() {
    if (searchResults) return searchResults;
    if (map) return visibleStores();
    return stores.slice();
  }

  /* Etichetta in alto a sinistra ("Tutti i negozi" / "N Negozi") */
  function refreshLabel() {
    if (!els.allLabel) return;
    var n;
    if (searchResults) {
      n = searchResults.length;
      els.allLabel.textContent = n + " " + (n === 1 ? i18n.storeOne : i18n.storeMany);
    } else if (map) {
      n = visibleIds.length;
      els.allLabel.textContent = (n === stores.length || n === 0)
        ? i18n.allStores : (n + " " + (n === 1 ? i18n.storeOne : i18n.storeMany));
    } else {
      els.allLabel.textContent = i18n.allStores;
    }
  }

  /* ── Sidebar: lista ────────────────────────────────────────────────────── */
  function openSidebar() {
    els.sidebar.classList.add("is-open");
    if (!activeStoreId) renderList();
  }
  function closeSidebar() {
    els.sidebar.classList.remove("is-open");
    activeStoreId = null;
    setActiveItem(null);
  }

  function renderList() {
    activeStoreId = null;
    els.sidebar.classList.remove("is-detail"); // header torna "Negozi"
    var list = currentStores();
    els.sidebarCount.textContent = "(" + list.length + ")";

    if (!list.length) {
      els.sidebarBody.innerHTML = searchResults
        ? '<p class="sl-empty">' + esc(i18n.emptySearchTitle) + '<br>' + esc(i18n.emptySearchHint) + '</p>'
        : '<p class="sl-empty">' + esc(i18n.emptyAreaTitle) + '<br>' + esc(i18n.emptyAreaHint) + '</p>';
      return;
    }

    var html = '<ul class="sl-list">';
    list.forEach(function (s) {
      html +=
        '<li class="sl-item" data-id="' + s.id + '">' +
          (s.type ? '<span class="sl-item__type">' + esc(s.type) + "</span>" : "") +
          '<p class="sl-item__name">' + esc(s.name) + "</p>" +
          '<p class="sl-item__addr">' + esc(addrLine(s)) + "</p>" +
        "</li>";
    });
    html += "</ul>";
    els.sidebarBody.innerHTML = html;

    els.sidebarBody.querySelectorAll(".sl-item").forEach(function (li) {
      li.addEventListener("click", function () {
        focusStore(numId(li.dataset.id));
      });
    });
  }

  /* Centra la mappa (se presente) sul negozio e ne apre il dettaglio */
  function focusStore(id) {
    var s = storeById(id);
    if (!s) return;
    showDetail(id); // segna il negozio attivo prima dell'evento 'idle' della mappa
    if (!map) return;
    var lat = Number(s.lat), lng = Number(s.lng);
    if (isNaN(lat) || isNaN(lng)) return;
    map.setCenter({ lat: lat, lng: lng });
    map.setZoom(18); // zoom quasi al massimo sul negozio selezionato
    // La sidebar copre la parte destra: sposta il negozio nell'area visibile.
    if (els.sidebar && els.sidebar.classList.contains("is-open")) {
      map.panBy(els.sidebar.offsetWidth / 2, 0);
    }
  }

  /* ── Sidebar: dettaglio ────────────────────────────────────────────────── */
  function showDetail(id) {
    var s = storeById(id);
    if (!s) return;
    activeStoreId = id;
    setActiveItem(id);
    els.sidebar.classList.add("is-detail"); // header mostra "‹ Tutti i negozi"
    els.sidebarCount.textContent = "";

    var rows = "";
    rows += detailRow("pin", esc(fullAddress(s)));
    if (s.phone) rows += detailRow("phone", '<a href="tel:' + esc(s.phone) + '">' + esc(s.phone) + "</a>");
    if (s.email) rows += detailRow("mail", '<a href="mailto:' + esc(s.email) + '">' + esc(s.email) + "</a>");
    if (s.website) rows += detailRow("web", '<a href="' + esc(s.website) + '" target="_blank" rel="noopener">' + esc(prettyUrl(s.website)) + "</a>");
    if (s.hours) rows += detailRow("clock", esc(s.hours));

    var dir = "https://www.google.com/maps/dir/?api=1&destination=" + encodeURIComponent(fullAddress(s));

    els.sidebarBody.innerHTML =
      '<div class="sl-detail">' +
        (s.type ? '<span class="sl-detail__type">' + esc(s.type) + "</span>" : "") +
        '<h2 class="sl-detail__name">' + esc(s.name) + "</h2>" +
        rows +
        '<div class="sl-detail__actions">' +
          '<a class="sl-btn" href="' + dir + '" target="_blank" rel="noopener">' + icon("directions") + " " + esc(i18n.directions) + "</a>" +
          (s.website ? '<a class="sl-btn sl-btn--ghost" href="' + esc(s.website) + '" target="_blank" rel="noopener">' + esc(i18n.visitSite) + '</a>' : "") +
        "</div>" +
      "</div>";

  }

  function detailRow(ic, html) {
    return '<div class="sl-detail__row">' + icon(ic) + "<span>" + html + "</span></div>";
  }

  function setActiveItem(id) {
    els.sidebarBody.querySelectorAll(".sl-item").forEach(function (li) {
      li.classList.toggle("is-active", id != null && sameId(li.dataset.id, id));
    });
  }

  /* ── Ricerca (filtro locale, nessuna API esterna) ──────────────────────── */
  /* Indice di ricerca: testo cercabile per store + elenco luoghi per i suggerimenti. */
  function buildSearchIndex() {
    stores.forEach(function (s) {
      s._search = [s.name, s.address, s.city, s.province, s.postalCode, s.country]
        .filter(Boolean).join(" ").toLowerCase();
    });

    var seen = {};
    suggestSource = [];
    stores.forEach(function (s) {
      [s.city, s.province, s.country].forEach(function (val) {
        if (!val) return;
        var label = String(val).trim();
        if (label.length < 3) return;            // salta i codici (es. "MI", "BY")
        var k = label.toLowerCase();
        if (seen[k]) return;
        seen[k] = true;
        suggestSource.push(label);
      });
    });
    suggestSource.sort();
  }

  /* rimuove gli accenti (à→a) per ricerche più tolleranti */
  function deburr(str) {
    str = String(str).toLowerCase();
    return str.normalize ? str.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : str;
  }
  /* spezza una stringa in token alfanumerici, ignorando virgole/spazi */
  function tokens(str) {
    return deburr(str).split(/[^a-z0-9]+/).filter(Boolean);
  }

  function matchStores(query) {
    var qt = tokens(query);
    if (!qt.length) return [];
    return stores.filter(function (s) {
      var hay = deburr(s._search);
      return qt.every(function (t) { return hay.indexOf(t) !== -1; });
    });
  }

  function onType() {
    var q = els.input.value.trim();
    els.clearBtn.classList.toggle("is-visible", q.length > 0);
    if (q.length < 2) { closeSuggest(); return; }

    var qt = tokens(q);
    var matches = suggestSource.filter(function (label) {
      var lt = tokens(label);
      return qt.every(function (t) {
        return lt.some(function (w) { return w.indexOf(t) === 0; }) || label.toLowerCase().indexOf(t) !== -1;
      });
    }).slice(0, 6);

    if (!matches.length) { closeSuggest(); return; }
    renderSuggest(matches);
  }

  function renderSuggest(labels) {
    els.suggest.innerHTML = labels.map(function (l) {
      return '<div class="sl-suggest__item" data-desc="' + esc(l) + '">' + esc(l) + "</div>";
    }).join("");
    els.suggest.classList.add("is-open");
    els.suggest.querySelectorAll(".sl-suggest__item").forEach(function (it) {
      it.addEventListener("click", function () {
        els.input.value = it.dataset.desc;
        closeSuggest();
        runSearch();
      });
    });
  }
  function closeSuggest() { els.suggest.classList.remove("is-open"); els.suggest.innerHTML = ""; }

  function runSearch() {
    var q = els.input.value.trim();
    if (!q) { clearSearch(); return; }
    els.clearBtn.classList.add("is-visible");
    closeSuggest();

    searchResults = matchStores(q);
    activeStoreId = null;

    openSidebar();      // renderizza la lista dai risultati
    refreshLabel();
    if (map && searchResults.length) fitToStores(searchResults);
  }

  /* Inquadra la mappa sui negozi passati, limitando lo zoom massimo */
  function fitToStores(list) {
    if (!list.length) return;
    if (list.length === 1) {
      map.setCenter({ lat: list[0].lat, lng: list[0].lng });
      map.setZoom(13);
      return;
    }
    var bounds = new google.maps.LatLngBounds();
    list.forEach(function (s) { bounds.extend({ lat: s.lat, lng: s.lng }); });
    map.fitBounds(bounds, 80);
    google.maps.event.addListenerOnce(map, "idle", function () {
      if (map.getZoom() > 14) map.setZoom(14);
    });
  }

  function clearSearch() {
    els.input.value = "";
    els.clearBtn.classList.remove("is-visible");
    closeSuggest();
    searchResults = null;
    activeStoreId = null;
    if (map) {
      map.setCenter({ lat: 30, lng: 20 });
      map.setZoom(defaultZoom);   // 'idle' → updateVisible aggiorna lista/etichetta
    } else {
      refreshLabel();
      if (els.sidebar.classList.contains("is-open")) renderList();
    }
  }

  /* ── Util ──────────────────────────────────────────────────────────────── */
  /* Confronto per stringa: l'id può arrivare come numero o stringa numerica
     (es. "42") a seconda della fonte dati; il match strict fallirebbe. */
  function sameId(a, b) { return String(a) === String(b); }
  function storeById(id) {
    for (var i = 0; i < stores.length; i++) if (sameId(stores[i].id, id)) return stores[i];
    return null;
  }
  function numId(v) { var n = Number(v); return isNaN(n) ? v : n; }
  function addrLine(s) {
    return [s.address, [s.postalCode, s.city].filter(Boolean).join(" "), s.country].filter(Boolean).join(", ");
  }
  function fullAddress(s) {
    return [s.address, [s.postalCode, s.city].filter(Boolean).join(" "),
      s.province, s.country].filter(Boolean).join(", ");
  }
  function prettyUrl(u) { return u.replace(/^https?:\/\//, "").replace(/\/$/, ""); }
  function esc(str) {
    return String(str == null ? "" : str)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }

  /* Avvio UI appena il DOM è pronto, indipendentemente da Google Maps */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  return { init: init, boot: boot, mapUnavailable: mapUnavailable };
})();

/* Auth Google Maps fallita: la mappa non si carica, ma ricerca/lista restano
   pienamente funzionanti. Mostriamo solo un avviso al posto della mappa. */
window.gm_authFailure = function () {
  if (window.SantiniStoreLocator) {
    window.SantiniStoreLocator.boot();
    window.SantiniStoreLocator.mapUnavailable();
  }
  if (window.console && console.warn) {
    console.warn("[Santini] Google Maps non autorizzato: la mappa non verrà mostrata, " +
      "ma ricerca ed elenco funzionano. Verifica i referrer HTTP / l'abilitazione di Maps JavaScript API.");
  }
};
